// extracted by mini-css-extract-plugin
var _1 = "_27Md6";
var _2 = "JcrpM";
export { _1 as "continent", _2 as "titleIcon" }
